import React, { useCallback, useMemo, useState } from 'react';
import { it, fr, de } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

export type UiContextType = {
  dateFnsLocale: typeof de;
  isUnauthorizedDialogVisible: boolean;
  showUnauthorizedDialog: () => void;
  setIsSearchFilterInProgress: (isInProgress: boolean) => void;
  isSearchFilterInProgress: boolean;
};

export const UiContext = React.createContext<UiContextType | null>(null);

const UiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const [isUnauthorizedDialogVisible, setIsUnauthorizedDialogVisible] = useState<boolean>(false);
  const [isSearchFilterInProgress, setIsSearchFilterInProgress] = useState<boolean>(false);

  const dateFnsLocale = useMemo(() => {
    switch (i18n.language) {
      case 'fr':
        return fr;
      case 'it':
        return it;
      default:
        return de;
    }
  }, [i18n.language]);

  const showUnauthorizedDialog = useCallback(() => {
    setIsUnauthorizedDialogVisible(true);
  }, []);

  const uiValues = useMemo(
    () => ({
      dateFnsLocale,
      isUnauthorizedDialogVisible,
      showUnauthorizedDialog,
      setIsSearchFilterInProgress,
      isSearchFilterInProgress
    }),
    [
      dateFnsLocale,
      isUnauthorizedDialogVisible,
      showUnauthorizedDialog,
      setIsSearchFilterInProgress,
      isSearchFilterInProgress
    ]
  );

  return <UiContext.Provider value={uiValues}>{children}</UiContext.Provider>;
};

export default UiProvider;
